import React, { useEffect, useState, useContext } from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Stack, Button, CircularProgress, Checkbox, Tooltip } from '@mui/material';
import { ExpandMore, Visibility, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import ticketApi from '../../api/ticketApi';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import { formatDate } from '../../utils/dateFormatter';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function TicketListPageMobile() {
  const { user } = useContext(AuthContext);
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('DESC');
  const navigate = useNavigate();
  const pageSize = 10;

  const fetchTickets = (pageNumber = 0) => {
    setLoading(true);
    const params = { page: pageNumber, size: pageSize, sort: `${sortField},${sortDirection}`, ...filters };
    ticketApi.list(filters,params)
      .then(res => {
        setTickets(res.data.content || []);
        setTotalPages(res.data.totalPages || 0);
        setPage(res.data.number || 0);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => fetchTickets(0), []);

  const openDeleteDialog = (id) => { setSelectedId(id); setOpenDeleteModal(true); };
  const closeDeleteDialog = () => { setSelectedId(null); setOpenDeleteModal(false); };
  const confirmDelete = async () => { try { await ticketApi.delete(selectedId); fetchTickets(page); } catch (err) { console.error(err); } closeDeleteDialog(); };

  return (
    <Container sx={{ mt: 2 }}>
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 2 }}>Tickets</Typography>
      {loading && <CircularProgress />}
     {/* Paginazione */}
     <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
       {Array.from({ length: totalPages }, (_, i) => (
         <Button key={i} variant={i === page ? 'contained' : 'outlined'} onClick={() => fetchTickets(i)}>{i + 1}</Button>
       ))}
     </Stack>
      <Stack spacing={2}>
        {tickets.map(t => (
          <Accordion key={t.id}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              {t.oggetto} - {t.stato}
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Priorità: {t.priorita}</Typography>
              <Typography>Livello: {t.livello}</Typography>
              <Typography>Stato: {t.stato}</Typography>

              <Typography>Data Creazione: {formatDate(t.createdAt)}</Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                <Button size="small" onClick={() => navigate(`/tickets/${t.id}`)} startIcon={<Visibility />}>Visualizza</Button>
                <ProtectedAction user={user} roles={['ADMIN']}>
                    <Button size="small" onClick={() => navigate(`/tickets/${t.id}`)}>Aggiorna Stato</Button>
                    <Button size="small" onClick={() => navigate(`/tickets/${t.id}`)}>Aggiorna Livello</Button>
                  <Button size="small" color="error" onClick={() => openDeleteDialog(t.id)} startIcon={<Delete />}>Elimina</Button>
                </ProtectedAction>
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>

      {/* Paginazione */}
      <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap' }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button key={i} variant={i === page ? 'contained' : 'outlined'} onClick={() => fetchTickets(i)}>{i + 1}</Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo ticket?"
      />
    </Container>
  );
}
